module.exports = __webpack_public_path__ + "img/yujing2.9a8081dd.png";